import { render, staticRenderFns } from "./datatable_client_logins.vue?vue&type=template&id=619b91fe"
import script from "./datatable_client_logins.vue?vue&type=script&lang=js"
export * from "./datatable_client_logins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports